import { routerMain } from 'constants/routerMain';
import { lazy } from 'react';

const ReferenceTemplateText = lazy(() => import('features/reference-template/reference-template-text/pages/ReferenceTemplateText'));
const ReferenceTemplateContract = lazy(() => import('features/reference-template/reference-template-contract/pages/ReferenceTemplateContract'));

const ReferenceTemplateRouter = [
    // document
    {
        path: routerMain.REFERENCE_TEMPLATE_TEXT,
        exact: true,
        component: ReferenceTemplateText,
    },
    {
        path: routerMain.REFERENCE_TEMPLATE_CONTRACT,
        exact: true,
        component: ReferenceTemplateContract,
    },
];
export default ReferenceTemplateRouter;
